import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Chip
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchComponent from '../SearchComponent'; // Adjust the import path as needed

const BenchmarkInputs = ({
  benchmarkData,
  handleDescriptionChange,
  handleStreamChange,
  baseUrl = '',
  includeMsci = false,
  searchProviders = null,
}) => {
  const benchmarkSource = benchmarkData?.source || '';
  const [expanded, setExpanded] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(benchmarkSource);
  const [selectedEtfMeta, setSelectedEtfMeta] = useState(null);

  useEffect(() => {
    setSelectedIndex(benchmarkSource);
    setSelectedEtfMeta((currentMeta) => (
      currentMeta?.symbol === benchmarkSource ? currentMeta : null
    ));
  }, [benchmarkSource]);

  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };

  const handleSelectIndex = (benchmarkName, metadata) => {
    setSelectedIndex(benchmarkName);
    handleStreamChange('source', benchmarkName);

    if (metadata) {
      setSelectedEtfMeta(metadata);
      if (metadata.name) {
        handleDescriptionChange('description', metadata.name);
      }
    }
  };

  return (
    <Accordion expanded={expanded} onChange={handleChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          {/* <TextField
            label="Description"
            variant="outlined"
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
              handleDescriptionChange('description', e.target.value);
            }}
            InputLabelProps={{ shrink: true }}
            sx={{
              width: `${description.length + 2}ch`,
              minWidth: '150px'
            }}
            onClick={(event) => event.stopPropagation()}
          /> */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 2 }}>
            {/* <Typography variant="caption" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            Primary Return Stream
            </Typography> */}
            <Chip
            label={selectedIndex}
            sx={{ backgroundColor: 'lightblue' }}
            />
            {selectedEtfMeta?.start_date && (
              <Typography variant="caption" sx={{ mt: 0.5 }}>
                {`Start: ${selectedEtfMeta.start_date}`}
              </Typography>
            )}
        </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ width: '100%' }}>
            <SearchComponent
              onSelect={handleSelectIndex}
              baseUrl={baseUrl}
              includeMsci={includeMsci}
              searchProviders={searchProviders}
            />
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default BenchmarkInputs;
